import React, { useState } from "react";
import styled from "styled-components";
import GuaranteeCompanySlider from "../slider/GuaranteeCompanySlider";
import Select from "../score/Select";

const Wrapper = styled.div`
  width: 100%;
`;

const AssuranceContainer = styled.div`
  height: fit-content;
  padding: 0 45px 0 43px;
  margin-bottom: 40px;
  margin-top: 44px;
  @media (max-width: 1100px) {
    padding: 0 30px 0 40px;
    margin-bottom: 40px;
  }
  @media (max-width: 720px) {
    padding: 0;
    margin-bottom: calc((40 / 1280) * 100vh);
    height: max-content;
    .title {
      padding: 0 calc((40 / 720) * 100vw);
    }
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  font-family: "Noto Sans KR", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div .icon {
    width: 20px;
    height: auto;
    @media (max-width: 720px) {
      width: calc((35 / 720) * 100vw);
    }
  }
`;

const Title = styled.p`
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.5px;
  color: #fff;
  font-family: "Noto Sans KR", sans-serif;
  @media (max-width: 1100px) {
    font-size: 22px;
  }
  @media (max-width: 720px) {
    font-size: calc((28 / 720) * 100vw);
  }
`;

const MoreDetails = styled.span`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.38px;
  color: #fff;
  opacity: 0.7;
  cursor: pointer;
  @media (max-width: 1100px) {
    margin-right: 3px;
    font-size: 22px;
  }
  @media (max-width: 720px) {
    margin-right: calc((3 / 720) * 100vw);
    font-size: calc((22 / 720) * 100vw);
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 759px;
  background-color: #37840c;
`;

const InfoContainer = styled.div`
  width: 100%;
  height: 171px;
  background-color: #2a2c2b;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #161717;
  * {
    font-size: 16px;
  }

  img {
    width: 16px;
    height: 18px;
    margin-right: 10px;
  }

  .top {
    padding: 0 85px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    * {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .bottom {
    padding: 0 50px;
    height: 50px;
    display: flex;
    align-items: center;

    > .info {
      width: 620px;
      height: 100%;
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        * {
          margin: 0;
        }
      }
    }
    .attack {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .possession {
    font-size: 18px;
  }
`;

const InfoBar = styled.div`
  width: 227px;
  height: 8px;
  border-radius: 2px;
  background-color: #000;
  margin-left: ${(props) => (props.type === "left" ? "10px" : "36px")};
  margin-right: ${(props) => (props.type === "left" ? "36px" : "10px")};
  position: relative;
  > div {
    position: absolute;
    border-radius: 2px;
    width: ${(props) => props.width};
    background-color: ${(props) =>
      props.type === "left" ? "#07ac40" : "#ffba5a"};
    z-index: 1;
    height: 100%;
    right: ${(props) => (props.type === "left" ? "0" : "none")};
    left: ${(props) => (props.type === "left" ? "none" : "0")};
  }
`;

const Card = styled.div`
  width: 16px;
  height: 22px;
  border-radius: 3px;
  background-color: ${(props) =>
    props.color === "yellow" ? "#ffba5a" : "#e74c5b"};
  margin-right: 10px;
`;

const VerticalBar = styled.div`
  width: 1px;
  height: 80%;
  object-fit: contain;
  opacity: 0.2;
  background-color: #fff;
  margin: 0 15px;
`;

const TeamContainer = styled.div`
  width: 100%;
  height: 247px;
  background-color: #2a2c2b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  > span {
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #ccc;
  }
  > .middle {
    width: 805px;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > .team {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;

      font-size: 25px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.5px;
      text-align: center;
      color: #fff;
      .rank {
        font-size: 17px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.34px;
        text-align: center;
        color: #fe7300;
      }
    }
    img {
      width: 40px;
    }
    > .middle {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      div {
        width: 72px;
        height: 26px;
        border-radius: 6px;
        background-color: #19793a;

        font-family: "Roboto", sans-serif;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.32px;
        text-align: center;
        color: #fff;
        margin-bottom: 9px;
      }
      span {
        object-fit: contain;
        opacity: 0.5;
        font-family: "Roboto", sans-serif;

        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
`;

const TeamScore = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 40px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.8px;
  text-align: center;
  color: ${(props) => (props.active ? "#f5c703" : "#fff")};
`;

const ButtonContainer = styled.div`
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.28px;
  text-align: center;
  color: #fff;
  cursor: pointer;

  .text {
    height: 100%;
    line-height: 30px;
  }

  > :nth-child(1) {
    width: 107px;
    height: 32px;
    border-radius: 6px;
    background-color: #be4853;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hot {
    width: 13px;
    margin-right: 5px;
  }
`;

const ContentsContainer = styled.div`
  width: 100%;
  padding: 0 50px;
`;

const ContentsTabContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #303231;
  margin-bottom: 39px;
  > div {
    display: flex;
  }
  img {
    width: 35px;
    margin-left: auto;
  }
`;

const ContentsTab = styled.div`
  width: 130px;
  height: 49px;
  background-color: ${(props) => (props.active ? "#3b3c3b" : "#303231")};
  margin-right: 1px;
  border-radius: 6px 6px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.3px;
  color: ${(props) => (props.active ? "#fff" : "#999999")};
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  display: ${(props) => !props.active && "none"};
`;

const ContentTitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  margin-bottom: 11px;

  .title {
    font-size: 20px;
    letter-spacing: -0.4px;
    text-align: center;
    color: #2196f5;
    > span {
      font-size: 20px;
      letter-spacing: -0.4px;
      text-align: center;
      color: #fff;
      margin-left: 6px;
    }
  }

  > div {
    display: flex;
    align-items: center;
    position: relative;
    > span {
      margin-right: 14px;

      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.3px;
      text-align: center;
      color: #fff;
      display: flex;
      align-items: center;
    }
  }
`;

const Table = styled.table`
  width: 100%;
  margin: 0;
  object-fit: contain;
  margin-bottom: 20px;

  th,
  td {
    height: 50px;
    /* border: 1px solid #202221; */
  }

  th {
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    color: #fff;
    background-color: #3b3c3b;
  }

  td {
    font-family: "Roboto", sans-serif;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: -0.3px;
    text-align: center;
    color: #ccc;
  }

  thead {
    .one {
      width: 243px;
    }
    .two {
      width: 141px;
    }
    .three {
      width: 303px;
    }
    .four {
      width: 118px;
    }
    .five {
      width: 303px;
    }
    .six {
      width: 137px;
    }
  }
`;

const ResultCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.28px;
  color: #fff;
`;

const Tbody = styled.tbody`
  background-color: #2a2c2b;
  .league {
    background-color: #303231;
  }
  .result {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .active {
    color: #2196f5;
  }
  .score {
    color: ${(props) => (props.type === "lose" ? "#e74c5b" : "")};
    color: ${(props) => (props.type === "draw" ? "#ffa42d" : "")};
    color: ${(props) => (props.type === "win" ? "#07ac40" : "")};
    letter-spacing: 3px;
  }
  ${ResultCircle} {
    background-color: ${(props) => (props.type === "lose" ? "#e74c5b" : "")};
    background-color: ${(props) => (props.type === "draw" ? "#ffa42d" : "")};
    background-color: ${(props) => (props.type === "win" ? "#07ac40" : "")};
  }
`;

const SummaryText = styled.div`
  width: 100%;

  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: #fff;
  margin-bottom: 40px;
  .win {
    color: #07ac40;
  }
  .draw {
    color: #ffa42d;
  }
  .lose {
    color: #e74c5b;
  }
`;

const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 22px;
`;

const CheckBoxOn = styled.div`
  background-image: url("/images/popup/Check.png");
  background-size: contain;
  width: 16px;
  height: 16px;
  @media (max-width: 720px) {
    width: calc((34 / 720) * 100vw);
    height: calc((34 / 1280) * 100vh);
  }
`;

const CheckBoxOff = styled.div`
  width: 16px;
  height: 16px;
  border: 1.5px solid #000;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 720px) {
    width: calc((34 / 720) * 100vw);
    height: calc((34 / 1280) * 100vh);
  }
`;

const CheckText = styled.span`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.3px;
  color: #fff;
  margin-left: 7px;
  @media (max-width: 720px) {
    font-size: calc((24 / 720) * 100vw);
  }
`;

const OptionContainer = styled.div`
  width: 100%;
  height: 46px;
  background-color: rgba(0, 0, 0, 0.9);
  padding-left: 21px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const OptionTeam = styled.div`
  width: 275px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ccc;

  > span {
    height: 100%;
    line-height: 24px;
  }
  > img {
    height: 100%;
  }
  > div {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.8px;
    text-align: center;
    color: #ccc;
  }
`;

const OptionSelectContainer = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-left: 10px;
  }
`;

const RankingTabContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const RankingTab = styled.div`
  width: 55px;
  height: 34px;
  border-radius: 6px;
  background-color: ${(props) => props.active && "#19793a"};
  margin-bottom: 20px;
  cursor: pointer;

  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: -0.3px;
  text-align: center;
  color: ${(props) => (props.active ? "#fff" : "#999999")};

  display: flex;
  align-items: center;
  justify-content: center;
`;

const RankingTable = styled.table`
  width: 100%;

  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #fff;
  margin-bottom: 30px;

  & {
    border-spacing: 0px;
  }

  th {
    background-color: #3b3c3b;
    font-weight: 500;
  }

  td {
    img {
      width: 17px;
    }
    border-top: 1px solid #202221;
  }

  th,
  td {
    height: 50px;
  }

  tr {
    > :nth-child(1) {
      width: 53px;
    }
    > :nth-child(2) {
      width: 35px;
    }
    > :nth-child(3) {
      width: 800px;
      text-align: start;
      padding-left: 35px;
    }
    > :nth-child(5) {
      color: #06ce4b;
    }
    > :nth-child(6) {
      color: #ffa42d;
    }
    > :nth-child(7) {
      color: #e74c5b;
    }
  }
`;

const RankingTbody = styled.tbody`
  background-color: #303231;
  border-spacing: 1px;

  tr {
    background-color: ${(props) => props.item.active && "#4e4f4e"};
    .image {
      background-image: ${(props) => "url(" + props.item?.logo + ")"};
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    > :last-child {
      color: #2196f5;
      background-color: #4e4f4e;
    }
  }
`;

const LiveSoccer = () => {
  const [contentsTab, setContentsTab] = useState(1);
  const [check, setCheck] = useState({
    home: false,
    away: false,
  });
  const [selectOne, setSelectOne] = useState({
    open: false,
    text: 5,
    list: [5, 10, 15],
  });
  const [selectTwo, setSelectTwo] = useState({
    open: false,
    text: 5,
    list: [5, 10, 15],
  });
  const [selectThree, setSelectThree] = useState({
    open: false,
    text: 5,
    list: [5, 10, 15],
  });

  const [relay, setRelay] = useState({
    open: false,
    text: "그래픽중계",
    list: ["그래픽중계", "실시간중계"],
  });

  const [quality, setQuality] = useState({
    open: false,
    text: "화질선택",
    list: ["1080p", "720p", "360p"],
  });

  const [multiView, setMultiView] = useState({
    open: false,
    text: "멀티뷰",
    list: ["기본(1화면)", "2멀티화면", "4멀티화면"],
  });

  const [rankingTab, setRankingTab] = useState(1);

  const tmpRankingList = [
    {
      logo: "/images/live/Team3.png",
      name: "시바스 과달라하라 우먼",
      totalGame: 0,
      win: 0,
      draw: 0,
      lose: 0,
      point: 6,
    },
    {
      logo: "/images/live/Team4.png",
      name: "즈남야 노긴스크",
      totalGame: 5,
      win: 5,
      draw: 5,
      lose: 5,
      point: 6,
    },
    {
      logo: "/images/live/Team3.png",
      name: "사라토프",
      totalGame: 3,
      win: 3,
      draw: 3,
      lose: 3,
      point: 3,
    },
    {
      logo: "/images/live/Team4.png",
      name: "시바스 과달라하라 우먼",
      totalGame: 3,
      win: 3,
      draw: 3,
      lose: 3,
      point: 3,
      active: true,
    },
    {
      logo: "/images/live/Team3.png",
      name: "즈남야 노긴스크",
      totalGame: 3,
      win: 3,
      draw: 3,
      lose: 3,
      point: 3,
    },
    {
      logo: "/images/live/Team4.png",
      name: "시바스 과달라하라 우먼",
      totalGame: 3,
      win: 3,
      draw: 3,
      lose: 3,
      point: 3,
    },
    {
      logo: "/images/live/Team3.png",
      name: "사라토프",
      totalGame: 3,
      win: 3,
      draw: 3,
      lose: 3,
      point: 3,
    },
    {
      logo: "/images/live/Team4.png",
      name: "즈남야 노긴스크",
      totalGame: 1,
      win: 1,
      draw: 1,
      lose: 1,
      point: 1,
    },
    {
      logo: "/images/live/Team3.png",
      name: "시바스 과달라하라 우먼",
      totalGame: 1,
      win: 1,
      draw: 1,
      lose: 1,
      point: 1,
      active: true,
    },
    {
      logo: "/images/live/Team4.png",
      name: "사라토프",
      totalGame: 1,
      win: 1,
      draw: 1,
      lose: 1,
      point: 1,
    },
    {
      logo: "/images/live/Team3.png",
      name: "시바스 과달라하라 우먼",
      totalGame: 1,
      win: 1,
      draw: 1,
      lose: 1,
      point: 1,
    },
    {
      logo: "/images/live/Team4.png",
      name: "즈남야 노긴스크",
      totalGame: 0,
      win: 0,
      draw: 0,
      lose: 0,
      point: 0,
    },
  ];

  return (
    <Wrapper>
      <VideoContainer></VideoContainer>
      <OptionContainer>
        <OptionTeam>
          <span>알 메사이미어</span>
          <img src="/images/live/Team4.png" alt=""></img>
          <div>vs</div>
          <img src="/images/live/Team3.png" alt=""></img>
          <span>하포엘 예루살렘</span>
        </OptionTeam>
        <OptionSelectContainer>
          <Select
            select={relay}
            setSelect={setRelay}
            width="133px"
            type="option"
            background="#2c2d2d"
            height="32px"
            name="relay"
          ></Select>
          <Select
            select={quality}
            setSelect={setQuality}
            width="111px"
            type="option"
            background="#2c2d2d"
            height="32px"
          ></Select>
          <Select
            select={multiView}
            setSelect={setMultiView}
            width="111px"
            type="option"
            background="#3081c3"
            height="32px"
            name="multi"
          ></Select>
          <ButtonContainer>
            <div>
              <img className="hot" src="/images/watchinglive/hot.png" alt="" />
              <div className="text">집중모드</div>
            </div>
          </ButtonContainer>
        </OptionSelectContainer>
      </OptionContainer>
      <InfoContainer>
        <div className="top">
          <div>
            <img src="/images/watchinglive/icon.png" alt="" />3
          </div>
          <div>
            <Card color="red"></Card>0
          </div>
          <div>
            <Card color="yellow"></Card>0
          </div>
          <div className="middle">
            <div>49%</div>
            <InfoBar type="left" width="49%">
              <div></div>
            </InfoBar>
            <div className="possession">소유</div>
            <InfoBar type="right" width="49%">
              <div></div>
            </InfoBar>
            <div>49%</div>
          </div>
          <div>
            <Card color="red"></Card>0
          </div>
          <div>
            <Card color="yellow"></Card>0
          </div>
          <div>
            <img src="/images/watchinglive/icon.png" alt="" />3
          </div>
        </div>
        <div className="bottom">
          <div className="info">
            <div>
              <div>48</div>
              <InfoBar type="left" width="49%">
                <div></div>
              </InfoBar>
              <div className="attack">공격</div>
              <InfoBar type="right" width="49%">
                <div></div>
              </InfoBar>
              <div>48</div>
            </div>
            <div>
              <div>48</div>
              <InfoBar type="left" width="49%">
                <div></div>
              </InfoBar>
              <div className="attack">위험공격</div>
              <InfoBar type="right" width="49%">
                <div></div>
              </InfoBar>
              <div>48</div>
            </div>
          </div>
          <VerticalBar></VerticalBar>
          <div className="info">
            <div>
              <div>48</div>
              <InfoBar type="left" width="49%">
                <div></div>
              </InfoBar>
              <div className="attack">공격</div>
              <InfoBar type="right" width="49%">
                <div></div>
              </InfoBar>
              <div>48</div>
            </div>
            <div>
              <div>48</div>
              <InfoBar type="left" width="49%">
                <div></div>
              </InfoBar>
              <div className="attack">위험공격</div>
              <InfoBar type="right" width="49%">
                <div></div>
              </InfoBar>
              <div>48</div>
            </div>
          </div>
        </div>
      </InfoContainer>
      <TeamContainer>
        <span>인터내셔널 클럽 프렌들리 2022/07/26 19:00:00</span>
        <div className="middle">
          <div className="team">
            <div>알 메사이미어</div>
            <span className="rank">(3위)</span>
          </div>
          <img src="/images/live/Team4.png" alt=""></img>
          <TeamScore active={true}>3</TeamScore>
          <div className="middle">
            <div>후반 56‘</div>
            <span>(HT 3:1)</span>
          </div>
          <TeamScore>1</TeamScore>
          <img src="/images/live/Team3.png" alt=""></img>
          <div className="team">
            <div>하포엘 예루살렘</div>
            <span className="rank">(2위)</span>
          </div>
        </div>
      </TeamContainer>
      <AssuranceContainer>
        <TitleContainer className="title">
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img className="icon" src="/images/main/Sidebar4.png" alt=""></img>
            <Title style={{ marginLeft: "7px" }}>스포시티 보증업체</Title>
          </div>
          <MoreDetails>더보기</MoreDetails>
        </TitleContainer>
        <GuaranteeCompanySlider />
      </AssuranceContainer>
      <ContentsContainer>
        <ContentsTabContainer>
          <div>
            <ContentsTab
              active={contentsTab === 1}
              onClick={() => setContentsTab(1)}
            >
              전력비교
            </ContentsTab>
            <ContentsTab
              active={contentsTab === 2}
              onClick={() => setContentsTab(2)}
            >
              순위비교
            </ContentsTab>
            <ContentsTab
              active={contentsTab === 3}
              onClick={() => setContentsTab(3)}
            >
              라인업
            </ContentsTab>
          </div>
          <img src="/images/live/Refresh.png" alt="" />
        </ContentsTabContainer>
        <Content active={contentsTab === 1}>
          <ContentTitleContainer>
            <span className="title">상대 전적</span>
            <div>
              <span>최근</span>
              <Select select={selectOne} setSelect={setSelectOne}></Select>
            </div>
          </ContentTitleContainer>
          <Table>
            <thead>
              <tr>
                <th className="one">리그명</th>
                <th className="two">날짜</th>
                <th className="three">홈팀</th>
                <th className="four">점수</th>
                <th className="five">원정팀</th>
                <th className="six">결과</th>
              </tr>
            </thead>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>가르활 FC</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
          </Table>
          <SummaryText>
            최근 5 , 마자틀란 우먼 승리 <span className="win">1</span>, 무승부{" "}
            <span className="draw">0</span> , 패배{" "}
            <span className="lose">4</span>, 승리 : 20.00%
          </SummaryText>

          <ContentTitleContainer>
            <span className="title">
              최근 경기 내역 <span>Uttarakhand FC</span>
            </span>
            <div>
              <span>최근</span>
              <Select select={selectTwo} setSelect={setSelectTwo}></Select>
              <CheckBoxContainer>
                {check.home ? (
                  <CheckBoxOn
                    onClick={() => setCheck({ ...check, home: false })}
                  />
                ) : (
                  <CheckBoxOff
                    onClick={() => setCheck({ ...check, home: true })}
                  />
                )}
                <CheckText>홈경기만</CheckText>
              </CheckBoxContainer>
            </div>
          </ContentTitleContainer>
          <Table>
            <thead>
              <tr>
                <th className="one">리그명</th>
                <th className="two">날짜</th>
                <th className="three">홈팀</th>
                <th className="four">점수</th>
                <th className="five">원정팀</th>
                <th className="six">결과</th>
              </tr>
            </thead>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td className="active">델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="win">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="draw">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>클럽 네카사 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>Uttarakhand FC</td>
                <td className="score">0-3</td>
                <td className="active">마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
          </Table>
          <SummaryText>
            최근 5 , 마자틀란 우먼 승리 <span className="win">1</span>, 무승부{" "}
            <span className="draw">0</span> , 패배{" "}
            <span className="lose">4</span>, 승리 : 20.00%
          </SummaryText>

          <ContentTitleContainer>
            <span className="title">
              최근 경기 내역 <span>Uttarakhand FC</span>
            </span>
            <div>
              <span>최근</span>
              <Select select={selectThree} setSelect={setSelectThree}></Select>
              <CheckBoxContainer>
                {check.home ? (
                  <CheckBoxOn
                    onClick={() => setCheck({ ...check, home: false })}
                  />
                ) : (
                  <CheckBoxOff
                    onClick={() => setCheck({ ...check, home: true })}
                  />
                )}
                <CheckText>원정경기만</CheckText>
              </CheckBoxContainer>
            </div>
          </ContentTitleContainer>
          <Table>
            <thead>
              <tr>
                <th className="one">리그명</th>
                <th className="two">날짜</th>
                <th className="three">홈팀</th>
                <th className="four">점수</th>
                <th className="five">원정팀</th>
                <th className="six">결과</th>
              </tr>
            </thead>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td className="active">델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="win">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="draw">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>클럽 네카사 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>Uttarakhand FC</td>
                <td className="score">0-3</td>
                <td className="active">마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
            <Tbody type="lose">
              <tr>
                <td className="league">IND DSD</td>
                <td>2022/07/22</td>
                <td>델리 FC</td>
                <td className="score">0-3</td>
                <td>마자틀란 우먼</td>
                <td className="result">
                  <ResultCircle>L</ResultCircle>
                </td>
              </tr>
            </Tbody>
          </Table>
          <SummaryText>
            최근 5 , 마자틀란 우먼 승리 <span className="win">1</span>, 무승부{" "}
            <span className="draw">0</span> , 패배{" "}
            <span className="lose">4</span>, 승리 : 20.00%
          </SummaryText>
        </Content>
        <Content active={contentsTab === 2}>
          <RankingTabContainer>
            <RankingTab
              active={rankingTab === 1}
              onClick={() => setRankingTab(1)}
            >
              전체
            </RankingTab>
            <RankingTab
              active={rankingTab === 2}
              onClick={() => setRankingTab(2)}
            >
              홈팀
            </RankingTab>
            <RankingTab
              active={rankingTab === 3}
              onClick={() => setRankingTab(3)}
            >
              원정팀
            </RankingTab>
          </RankingTabContainer>
          <RankingTable>
            <thead>
              <tr>
                <th>#</th>
                <th>팀</th>
                <th></th>
                <th>경기수</th>
                <th>승리</th>
                <th>무승부</th>
                <th>패배</th>
                <th>승점</th>
              </tr>
            </thead>
            {tmpRankingList.map((item, idx) => (
              <RankingTbody item={item}>
                <tr>
                  <td>{idx + 1}</td>
                  <td className="image"></td>
                  <td>{item.name}</td>
                  <td> {item.totalGame}</td>
                  <td> {item.win}</td>
                  <td> {item.draw}</td>
                  <td> {item.lose}</td>
                  <td> {item.point}</td>
                </tr>
              </RankingTbody>
            ))}
          </RankingTable>
        </Content>
      </ContentsContainer>
    </Wrapper>
  );
};

export default LiveSoccer;
